import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import HomeScreen from './home';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (
       
        <LayoutContent showLamp={false} showPincode={false} showLogo={false} showFooter={false} showBack={false} showImageTop={false} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div style={{background: "#000", position: 'absolute', left: 0}}>
               
                <div  onClick={()=> setShowHome(true)}>
                    <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/full-screen-LA-CANTERA-ELIZABETH-V2.jpg')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 10,
                                width: '100%',
                                 pointerEvents: 'none',
                                height:900,
                                objectFit: 'contain',
                                borderRadius: 14,
                               
                               
                            }}
                    />
                    
                    <div
                     onClick={()=> setShowHome(true)}
                        style={{
                        width: 110,
                        height: 50,
                        background: '#fff',
                        marginTop: 5,
                        padding: 10,
                        display: 'flex',
                        alignItems: 'center',
                        alignSelf: "center",
                        position: 'absolute',
                        left: 310,
                        borderRadius: 20,
                       display: 'flex',
                       justifyContent: 'center',
                       alignItems: 'center',
                        
                    }}>
                        <p style={{
                            color: 'black',
                            textAlign: 'center',
                            fontSize: 20,
                            fontWeight: "bold",
                            
                        }}>
                            See menu
                        </p>
                    </div>
                </div>
                

               
            </div>

            {showHome && <HomeScreen setShowBar={setShowBar} />}
            </LayoutContent>
           
    );
}

export default Index;